import moment from 'moment'

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  UserInfo,
  Group,
  Stack,
} from '@collaborate-health/uikit'

import { useApprovedCertificateTypes } from '../../hooks'
import { UserQualification } from '../../types'

import UserQualificationStatusChip from '../UserQualificationStatusChip'
import QualificationCertificateTypeCard from '../QualificationCertificateTypeCard'

import InfoRow from './InfoRow'
import { GroupWrapper } from './ViewUserQualificationDialog.styles'

export interface ViewUserQualificationDialogProps {
  open: boolean
  onClose: () => void
  onExited?: () => void
  qualification?: UserQualification | null
}

const ViewUserQualificationDialog: React.FC<ViewUserQualificationDialogProps> = ({
  open,
  qualification,
  onClose,
  onExited,
}) => {
  const { approvedCertificateTypeIds, loading } = useApprovedCertificateTypes({
    userGuid: qualification?.AssignedToUserId,
  })

  return (
    <Dialog open={open} onClose={onClose} TransitionProps={{ onExited }} fullWidth maxWidth='md' maxHeight='70vh'>
      <DialogTitle>User qualification</DialogTitle>
      <DialogContent overflow='hidden'>
        <Stack direction='row' spacing={2.5} overflow='hidden'>
          <GroupWrapper>
            <Group fullHeight overflow='auto' fullWidth>
              <Stack spacing={3}>
                <InfoRow label='Version'>{qualification?.QualificationVersionName}</InfoRow>
                <InfoRow label='Status'>
                  {qualification?.StatusId && <UserQualificationStatusChip status={qualification.StatusId} />}
                </InfoRow>
                <InfoRow label='Created on'>
                  {qualification?.CreatedOn &&
                    moment(qualification.CreatedOn, 'YYYY-MM-DDTHH:mm:ss.SSSSSS').format('D MMMM YYYY')}
                </InfoRow>
                <InfoRow label='Version expires'>
                  {qualification?.QualificationVersionExpirationDate
                    ? moment(qualification.QualificationVersionExpirationDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSS').format(
                        'D MMMM YYYY'
                      )
                    : 'Unlimited'}
                </InfoRow>
                <InfoRow label='Assigned by'>
                  <Stack maxWidth={300}>
                    <UserInfo avatar={false} item={qualification?.AssignerUser} />
                  </Stack>
                </InfoRow>
                <InfoRow label='Assigned to'>
                  <Stack maxWidth={300}>
                    <UserInfo avatar={false} item={qualification?.AssignedUser} />
                  </Stack>
                </InfoRow>
              </Stack>
            </Group>
          </GroupWrapper>
          <GroupWrapper>
            <Group fullHeight overflow='auto' fullWidth>
              <Stack gap={1.5}>
                {qualification?.QualificationVersionCertificateTypes?.map((certificateType) => (
                  <QualificationCertificateTypeCard
                    key={certificateType.Id}
                    loading={loading}
                    certificateType={certificateType}
                    approved={approvedCertificateTypeIds.includes(certificateType.Id)}
                  />
                ))}
              </Stack>
            </Group>
          </GroupWrapper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewUserQualificationDialog

